import Skeleton from '../../../../components/Skeleton/Skeleton';

import './AiAnswerSkeleton.styles.scss';

const LINE_WIDTHS = ['100%', '95%', '90%', '97%', '80%', '60%'];

const AiAnswerSkeleton = () => {
    return (
        <output className="AiAnswerSkeleton" aria-busy="true" aria-label="Loading AI generated answer">
            {LINE_WIDTHS.map((width, index) => (
                <Skeleton key={index} className="AiAnswerSkeleton__line" height={14} radius={2} style={{ width }} />
            ))}
        </output>
    );
};

export default AiAnswerSkeleton;
